import { z } from 'zod';

export const CreateVoucherBatchSchema = z
  .object({
    voucherName: z.string().min(1, { message: 'Event name is required' }),
    golfCourseId: z.string().min(1, { message: 'Golf course is required' }),
    validFor: z.string().min(1, { message: 'Date is required' }),
    voucherCount: z
      .number({
        required_error: 'Quantity is required',
        invalid_type_error: 'Quantity must be a number',
      })
      .int('Quantity must be an integer')
      .min(1, { message: 'Quantity must be at least 1' }),
    rewardTierId: z.string().min(1, { message: 'Reward tier is required' }),
    type: z.literal('corporate'),
  })
  .refine(
    (data) => {
      if (!data.validFor) {
        return true;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return new Date(data.validFor) >= today;
    },
    {
      message: 'Date cannot be in the past',
      path: ['validFor'],
    }
  );
